import { render, staticRenderFns } from "./LiberarAvisos.vue?vue&type=template&id=3113411a"
import script from "./LiberarAvisos.vue?vue&type=script&lang=ts"
export * from "./LiberarAvisos.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports